module.exports = __webpack_public_path__ + "static/media/order-flow.864d75e8.png";